import React, { createContext } from 'react';

const AirDropContext = createContext({
  additionalHeaders: {},
  applicationRootUrl: '',
  accountRootUrl: '',
  customSupportLinkUrl: '',
  createAccountCountries: [],
  CLIENT_ID: '',
  pageLayout: '',
  logoTreatment: '',
  okurl: '',
  errurl: '',
  roles: [],
  resetPassword: '',
  studyLevels: [],
  siteid: '',
  webCredentialsUrl: '',
  loginRootUrl: '',
  userSessionThreshold: 5,
  signupConfig: { url: 'https://pearson.com', show: true, type: 'createAccount' },
  LOGIN_URL_PREFIX: '',
  collapseNameFields: true,
  showRequiredFieldIndicators: false,
  passwordProfile: '',
  applySMSValidations: false,
  applyMLMValidations: false,
  applyHEDValidations: false,
  chooseAccountType: false,
  showKidFriendlyIcons: false,
  sesstype: 'fr',
  username: '',
  resetPasswordExpireFlag: false,
  enableResetPwViaText: '',
  masterResetPwViaTextEnabled: '',
  showSecurityQuestions: false,
  securityQuestionEscrowExpired: false,
  securityQuestions: [],
  securityQuestionsValidateToken: '',
  IDP_PARTNER_NAME: '',
  IDP_DISPLAY_NAME: '',
  signInErrorId: '',
  showBackLinkOnSessionEndedDialog: false,
  attachNuFlagFollowingAccountCreation: true,
  GOOGLE_RECAPTCHAV3_SITEKEY: 'XYZ',
  recaptchaOptions: {
    enabled: true,
  },
  partnerCustomizedAttributesJSON: {},
  socialSignin: [
    {
      service: 'googleV2',
      url: 'www.google.com',
      escrow: '',
    },
  ],
  socialSigninV2Error: {
    status: 0,
    piuiErrorCode: '',
    errorCode: '',
    errorMessage: '',
  },
  showSchoolDomain: '',
  showSchoolCode: '',
  footerLinks: [{ label: '', url: '' }],
  locale: '',
  defaultLocale: 'US',
  showRememberMe: false,
  defaultRememberMe: false,
  isForceResetPassword: false,
  showCountry: false,
  showMarketingOptIn: true,
  thirdPartyMarketingVisible: true,
  showSignInLink: true,
  auoUserData: {
    firstName: '',
    email: '', // verify email and username are same
    homeCountryCode: '',
    institutionType: '',
    idpPartnerName: '', // use for lms
  },
  auoCreatePasswordExpiredFlag: false,
  suppressAccountCreationCapability: false,
  backgroundImageUrl: '',
  cloudfrontRootUrl: '',
  loginUrl: '',
  is_linkAccounts: false,
  ownerId: '',
  linkAccounts_url: '',
  PI_SESSION: {
    linkAccounts_url: '',
    linkAccounts_escrow: 'dB8tp6OCAS',
  },
  DATA: {
    resetPwLinksData: null,
  },
  linkAccounts_success_url:
    'http://dev-piapi-internal.dev-openclass.com/login/linkAccountsSuccess',
  linkAccounts_fail_url:
    'http://dev-piapi-internal.dev-openclass.com/login/linkAccountsFail',
  institutionId: 'eyJraWQiOiJrMTEzuz',
  idpId: '55ca08ace4b0e780642ecb82',
  idpUserId: 'random1236678',
  showInstitutionEducator: '',
  showInstitutionStudent: '',
  cookieConsentGroups: undefined,
  showRoleField: true,
  role: 'INSTRUCTOR',
  isTpiNewUserFlow: false,
  showStudyLevel: false,
  showStudyLevelPrivacyInterstitial: true,
  dobFormatType: 'month_year',
  dobFormatTypePrivacyInterstitial: 'month_year',
  skipCreateAccountConfirmationPage: false,
  iscourseaware: false,
  addRoleToSuccessUrl: false,
  data: { account: { institutionId: 'eyJraWQiOiJrMTEzuz' } },
  enableSmsRateLimit: false,
  waitTimeForCodeResend: 60,
  PEPItalyUserJourney: true,
  sanomaPrivacyPolicyUrl: 'https://link.sanomaitalia.it/112DDD2D',
  pPlusLearnMoreUrl: 'https://www.pearson.com/channels?CEP=plusLoginScreen',
  phoneNumberSettings: {
    defaultCountry: 'US',
    allowedCountries:
    [
      'CA',
      'GB',
      'US',
    ],
  },
  enableSignInWithCode: false,
  domainForInstructorAccessUrls: '',
  showHelpIconForPendoRC: false,
});

interface AirDropProps {
  children: any;
}

export function AirDropProvider(props: AirDropProps) {
  const { children } = props;
  return (
    <AirDropContext.Provider value={window.appAirDrop.config}>
      {children}
    </AirDropContext.Provider>
  );
}

export { AirDropContext };
